<template>
  <div>
    <div id="dContent" style="position: relative;">
      <div id="dContent_1" v-show="showimg">
        <div id="cNav">
          <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
            :to="{path:'/Exhibitioninfo/permanent'}">常设展览</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{ title }}
        </div>
        <div id="lbimg">
          <el-carousel id="hCarousel" :interval="5000" arrow="always">
            <el-carousel-item v-for="item in dataimg" :key="item" style="width: 100%;height: 100%;">
              <img style="width: 100%;height: 100%;" :src="item">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div id="introduce">
          <div style="text-align: center;font-size: 20px;font-weight: bold;line-height: 3.125rem;">{{tableData.title}}</div>
          <div v-if="tableData.videotype=='102'" >
            <el-row :gutter="15" class="d-video">
              <el-col style="width: 70%;">
                  <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                    style="width: 100%;"></video>
              </el-col>
            </el-row>
          </div>
          <div v-html="tableData.contents"></div>
        </div>
      </div>
      <div id="dContent_2" v-show="!showimg">
        <div id="cNav">
          <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
            :to="{path:'/Exhibitioninfo/permanent'}">常设展览</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{ title }}
        </div>
        <div id="introduce">
          <div style="text-align: center;font-size: 20px;font-weight: bold;line-height: 3.125rem;">{{tableData.title}}</div>
          <div v-if="tableData.videotype=='102'" >
            <el-row :gutter="15" class="d-video">
              <el-col style="width: 70%;">
                  <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                    style="width: 100%;"></video>
              </el-col>
            </el-row>
          </div>
          <div v-html="tableData.contents"></div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
    <div id="mdContent" style="position: relative;">
      <div id="mdContent_1" v-show="mshowimg">
        <div id="mcNav">
          <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
            :to="{path:'/Exhibitioninfo/permanent'}">常设展览</router-link>
        </div>
        <div style="height: 200px;">
          <el-carousel style="width: 100%;height: 100%;" :interval="5000" arrow="always">
            <el-carousel-item v-for="item in mdataimg" :key="item" style="width: 100%;height: 100%;">
              <img style="width: 100%;height: 100%;" :src="item">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div id="mintroduce">
          <div style="text-align: center;font-size: 20px;font-weight: bold;line-height: 3.125rem;">{{tableData.title}}</div>
          <div v-if="tableData.videotype=='102'" >
            <el-row :gutter="15" class="d-video">
              <el-col style="width: 70%;">
                  <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                    style="width: 100%;"></video>
              </el-col>
            </el-row>
          </div>
          <div v-html="mtableData.contents"></div>
        </div>
      </div>
      <div id="mdContent_2" v-show="!mshowimg">
        <div id="mcNav">
          <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
            :to="{path:'/Exhibitioninfo/permanent'}">常设展览</router-link>
        </div>
        <div id="mintroduce">
          <div style="text-align: center;font-size: 20px;font-weight: bold;line-height: 3.125rem;">{{tableData.title}}</div>
          <div v-if="tableData.videotype=='102'" >
            <el-row :gutter="15" class="d-video">
              <el-col style="width: 70%;">
                  <video id="myVideo" class="video-js" tabindex="2" mediatype="video" loop="loop" controls="controls" preload="auto" :src="tableData.video"
                    style="width: 100%;"></video>
              </el-col>
            </el-row>
          </div>
          <div v-html="mtableData.contents"></div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        imgData: [],
        dataimg: [],
        id: '',
        title: '',
        showimg: false,
        mtableData: [],
        mimgData: [],
        mdataimg: [],
        mtitle: '',
        mshowimg: false,
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1
        }
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("mdContent").style.display = "block";
        this.mhandleSearch();
      } else {
        document.getElementById("dContent").style.display = "block";
        this.handleSearch();
        let eWidth = document.body.clientWidth;
        document.getElementById("lbimg").style.width = eWidth * 0.7 + "px";
        document.getElementById("lbimg").style.height = eWidth * 0.4 + "px";
        document.getElementById("hCarousel").style.width = eWidth * 0.7 + "px";
        document.getElementById("hCarousel").style.height = eWidth * 0.4 + "px";
      }
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        this.search();
      },
      mhandleSearch() {
        this.msearch();
      },

      isBlank(str) {
        return (
          str == null ||
          false ||
          str === "" ||
          str.trim() === "" ||
          str.toLocaleLowerCase().trim() === "null"
        );
      },
      // 查询列表
      search: function() {
        let that = this;
        this.id = this.$route.query.id;
        let url = this.HOST + '/api/v1/permanent/permanentDetails?id=' + this.id + '';
        let urlimg = this.HOST + '/api/v1/permanent/permanentDetails?id=' + this.id + '';
        this.imgData.splice(0, this.imgData.length)
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.title = cData.data.title;
          if(!that.isBlank(cData.data.images)){
            that.showimg = true;
            that.dataimg = cData.data.images.split("#")
          }else{
            that.showimg = false
          }
          that.tableData = cData.data;
        }).catch(function(error) {
          console.log(error);
        })
      },
      msearch: function() {
        let that = this;
        this.id = this.$route.query.id;
        let url = this.HOST + '/api/v1/permanent/permanentDetails?id=' + this.id + '';
        let urlimg = this.HOST + '/api/v1/permanent/permanentDetails?id=' + this.id + '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.mtitle = cData.data.title;
          that.mtableData = cData.data;
          if(!that.isBlank(cData.data.images)){
            that.mshowimg = true;
            that.mdataimg = cData.data.images.split("#")
          }else{
            that.mshowimg = false
          }
        }).catch(function(error) {
          console.log(error);
        })
      }
    }
  }
</script>

<style scoped>
  #dContent {
    display: none;
    width: 70%;
    margin: 0 15%;
  }

  #dContent>#dContent_1>#cNav,
  #dContent>#dContent_2>#cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #dContent>#dContent_1>#cNav>span:nth-child(1),
  #dContent>#dContent_1>#cNav>span:nth-child(2),
  #dContent>#dContent_2>#cNav>span:nth-child(1),
  #dContent>#dContent_2>#cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #dContent>#dContent_1>#cNav>span:nth-child(1):hover,
  #dContent>#dContent_1>#cNav>span:nth-child(2):hover,
  #dContent>#dContent_2>#cNav>span:nth-child(1):hover,
  #dContent>#dContent_2>#cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  #swipercontainertop {
    height: 450px;
  }

  #swipercontainerbottom {
    height: 150px;
  }

  .swiper-container {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .gallery-top {
    height: 80%;
    width: 100%;
  }

  .gallery-thumbs {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }

  #introduce {
    text-align: left;
    line-height: 40px;
    margin-bottom: 50px;
    font-size: 18px;
  }

  /*mobile*/
  #mdContent {
    display: none;
    margin: auto 20px;
  }

  #mdContent>#mdContent_1>#mcNav,
  #mdContent>#mdContent_2>#mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mdContent>#mdContent_1>#mcNav>span:nth-child(1),
  #mdContent>#mdContent_1>#mcNav>span:nth-child(2),
  #mdContent>#mdContent_2>#mcNav>span:nth-child(1),
  #mdContent>#mdContent_2>#mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mdContent>#mdContent_1>#mcNav>span:nth-child(1):hover,
  #mdContent>#mdContent_1>#mcNav>span:nth-child(2):hover,
  #mdContent>#mdContent_2>#mcNav>span:nth-child(1):hover,
  #mdContent>#mdContent_2>#mcNav>span:nth-child(2):hover {
    color: #mFF9900;
  }

  #mswipercontainertop {
    height: 450px;
  }

  #mswipercontainerbottom {
    height: 150px;
  }

  .swiper-container {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
  }

  .swiper-slide {
    background-size: cover;
    background-position: center;
  }

  .gallery-top {
    height: 80%;
    width: 100%;
  }

  .gallery-thumbs {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
  }

  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
  }

  .gallery-thumbs .swiper-slide-thumb-active {
    opacity: 1;
  }

  #mintroduce {
    text-align: left;
    line-height: 30px;
    margin-bottom: 50px;
    font-size: 14px;
  }
  .d-video {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 30px 0;
  }

  .nav-video {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/exhibitioninfoDetials/permanentDetials.vue